import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'loyaltic-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CookieComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
